import React from "react"
import Tasks from "../../components/Tasks"
import TankTemp from "../../components/TankTemp"
import { Grid } from "@mui/material"

export default function dashboard({ open }) {
  return (
    <Grid container spacing={3} style={{ padding: 20 }}>
      <Grid item sm={6} xs={12}>
        <TankTemp />
      </Grid>
      <Grid item sm={4} xs={12}>
        <Tasks />
      </Grid>
    </Grid>
  )
}
